import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import FilterPopover from "@ui/internal/components/filter-popover";
import { usePathname } from "@utils/hook/index.hook";
import { QueryMetaData } from "@utils/interface/index.interface";
import { EnterpriseTestimonialData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import React, { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import TestimonialForm from "./form/index.form";

type Props = {};
const index: React.FC<Props> = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();

  const { data, isPending, refetch, error } = useListData<
    QueryMetaData<EnterpriseTestimonialData, any>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      is_show: searchParams.get("status") || "",
    },
    endpoint: endpoint["enterprise-testimonials"],
    key: `${pathname}-listing`,
    window: true,
  });

  useEffect(() => {
    if (
      //@ts-ignore
      error?.status === 404 &&
      error?.data?.detail === "Invalid page."
    ) {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const groupRefetch = () => {
    refetch();
  };

  const { mutate } = usePostData();
  const toggleActiveStatus = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["enterprise-testimonials"],
        data: {
          is_show: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (data) {
            const newItems = data.data.results.map((item) =>
              item.id === id ? { ...item, is_show: state } : item
            );
            console.log("new items", newItems);
            data.data.results = newItems;
          }
        },
        onError: (data) => {
          console.log(data);
        },
      }
    );
  };

  const columns = ColumnList({ refetch: groupRefetch, toggleActiveStatus });

  const rows = useMemo(() => data?.data?.results ?? [], [data]);

  return (
    <>
      <TableCard
        bulkActions
        formId={pathname + "testimonial"}
        table_content={{
          mode: "default",
          type: pathname,
        }}
        form={<TestimonialForm />}
        showOrientationSecond
        tableHeaderData={[
          {
            id: 1,
            name: "All",
            count: data?.data?.count || 0,
          },
        ]}
        grid={
          <GeneralCard
            isChecked={false}
            type={"testimonial"}
            showCheck
            content={{
              username: "Yunika Shakya",
              userdesignation: "UI/UX Designer",
              userimage: "",
              image: "",
              description:
                "Digital Marketing Mentorgital Marketing Mentorgital Marketing Mentor",
            }}
            onToggleStatus={toggleActiveStatus}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        inject_ui_table_actions={
          <FilterPopover
            filters={[
              {
                label: "Testimonial Status",
                searchKey: "status",
                radio: true,
                defaultOptions: [
                  {
                    label: "Featured",
                    value: "true",
                  },
                  {
                    label: "Non-Featured",
                    value: "false",
                  },
                ],
              },
            ]}
          />
        }
        sortableFilter={{
          search,
          ordering: searchParams.get("ordering") || "order",
          is_show: searchParams.get("status") || "",
          section: "",
        }}
        endpoint={endpoint["enterprise-testimonials"]}
        columns={columns}
        rows={rows}
        refetch={groupRefetch}
        isPending={isPending}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
